/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineSharedClassRoomDisciplinesStatus200,
  GetApiV1ClassroomdisciplineSharedClassRoomDisciplinesStatus401,
  GetApiV1ClassroomdisciplineSharedClassRoomDisciplinesStatusQueryParams,
  GetApiV1ClassroomdisciplineSharedClassRoomDisciplinesStatusQueryResponse,
} from "../../types/classPlanningSharedController/GetApiV1ClassroomdisciplineSharedClassRoomDisciplinesStatus.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

export const getApiV1ClassroomdisciplineSharedClassRoomDisciplinesStatusQueryParamsSchema =
  z.object({
    culture: z.string().default("pt-BR"),
  }) as unknown as ToZod<GetApiV1ClassroomdisciplineSharedClassRoomDisciplinesStatusQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineSharedClassRoomDisciplinesStatus200Schema =
  z.array(
    z.lazy(() => dropDownListViewModelSchema),
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineSharedClassRoomDisciplinesStatus200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineSharedClassRoomDisciplinesStatus401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineSharedClassRoomDisciplinesStatus401>;

export const getApiV1ClassroomdisciplineSharedClassRoomDisciplinesStatusQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineSharedClassRoomDisciplinesStatus200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineSharedClassRoomDisciplinesStatusQueryResponse>;
